module.exports = "/images/aerial-8.jpg";